import { Preferences } from "../../profile/objects/preferences";
import { DEFAULT_COLUMN, CORPORATE_CODE_MODULE } from "../constant/corporateCodeConstant";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";

export const setCorporateCodePreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: CORPORATE_CODE_MODULE,
    default_columns: DEFAULT_COLUMN,
    default_order_by: '-created_date',
    default_order: 'asc',
});